@if (!loaded()) {
    <div class="loading-overlay-linear">
        <div class="loading-content linear" [ngClass]="{ center: center() }">
            <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
            <span class="text-primary text-uppercase">{{ message() }}</span>
        </div>
    </div>
}
